<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      :option-label="option_label"
      :option-value="option_value"
      :emit-value="emit_value"
      :map-options="map_option"
      :loading="itemsLoading"
      :options="options"
      @filter="filterFn"
      v-bind="siteCFG.fields.general"
      :dense="dense"
      :clearable="clearable"
      @input="$emit('changed', model)"
      :multiple="multiple"
      :use-chips="useChips"
      :readonly="readonly"
    >
      <template v-if="!useChips" v-slot:selected-item="scope">
        <div style="max-width: 70%" class="ellipsis">
          <span v-if="!useChips">
            {{ scope.opt[option_label] }}
          </span>
        </div>
      </template>
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import moment from "moment";

  export default {
    props: {
      id: {
        default: null,
      },
      label: {
        type: String,
        default: "Autocomplete",
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      items: {
        default: [],
      },
      itemsLoading: {
        type: Boolean,
        default: false,
      },
      option_label: {
        type: String,
        default: "name",
      },
      option_value: {
        type: String,
        default: "id",
      },
      emit_value: {
        type: Boolean,
        default: true,
      },
      map_option: {
        type: Boolean,
        default: true,
      },
      excludeList: {
        default: null,
      },
      dense: {
        default: false,
      },
      clearable: {
        default: false,
      },
      singleLine: {
        default: false,
      },
      multiple: {
        default: false,
      },
      useChips: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        siteCFG: "settings/siteCFG",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      items: function () {
        this.init();
      },
      excludeList: function () {
        this.setupExcludeReferences();
      },
    },
    data: () => ({
      model: null,
      options: [],
      excludeListReferences: {},
    }),
    mounted() {
      this.init();
      this.setupExcludeReferences();
    },
    methods: {
      init() {
        this.options = JSON.parse(JSON.stringify(this.items));
        this.model = this.id;
      },
      setupExcludeReferences() {
        this.excludeListReferences = {};
        if (this.excludeList) {
          this.excludeList.forEach((element) => {
            this.excludeListReferences[element[this.option_value]] = element;
          });
        }
      },
      filterFn(val, update) {
        if (val === "") {
          update(() => {
            this.options = JSON.parse(JSON.stringify(this.items)).filter(
              (opt) => {
                return !this.excludeListReferences[opt[this.option_value]];
              }
            );
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = this.items.filter((v) => {
              let textMatch =
                v[this.option_label].toLowerCase().indexOf(needle) > -1;
              let notExcluded = !this.excludeListReferences[v[this.option_value]];
              return textMatch && notExcluded;
            });
          });
        }
      },
    },
  };
</script>
